import TableSkeleton from '../../../components/loaders/TableSkeleton';
import ListHeader from '../../../components/ListHeader';
import { useTranslation } from 'react-i18next';
import AccessoriesTableContainer from '../../../modules/accessories/components/AccessoriesTableContainer';
import useModuleTableHelpers from '../../../hooks/useModuleTableHelpers';
import { hasPermission } from '../../../utils/HelperFunctions';
import Button from '../../../components/buttons/Button';

const Accessories = () => {
  const { t } = useTranslation();

  const { apiData, apiDataLoading, paginationEle, searchEle } = useModuleTableHelpers({
    route: 'admin/accessories',
    withBreadcrumb: true,
    withSearch: true,
    breadcrumbTitle: t('links.accessories'),
    withPagination: true,
    queryKey: 'accessories',
    customSearchPlaceholder: `${t("search_by")} ${t("name")} ${t("or")} ${t("code")}`
  });

  const tableHeaders = [
    { label: "#"},
    { label: t('code') },
    { label: t('name') },
    { label: t('new_or_used') },
    { label: t('price') },
    // { label: t('model') },
    // { label: t('variant') },
    { label: t('hidden') },
    hasPermission(['accessories.edit']) && { label: t('actions'), customClass: 'actions_col' }
  ];

  if (apiDataLoading && !apiData) return <TableSkeleton columns={6} withoutButton />;

  return (
    <div className="accessories-page-container">
      <ListHeader customClass='table_filters'>
        <div className="filter_container">
          {searchEle}
        </div>
        {hasPermission(['accessories.edit']) && <Button text={t('create_accessory')} link="/accessories/create-accessory" />}
      </ListHeader>
      <AccessoriesTableContainer tableHeaders={tableHeaders} data={apiData} noDataMessage={t('no_accessories_found')} lessColumns />
      {paginationEle}
    </div>
  );
};

export default Accessories;
